import { mountApp } from '@/main'
import App from '@/views/users/registrations/new_user_certified_partner_serialnos'

let locale = 'en'
try {
  locale = document.getElementById('main').getAttribute('data-user-locale')
} catch (err) {
  console.error(err)
}

mountApp(
  {
    App,
    mountPoint: '#certified-partner-serialnos-mountpoint',
    locale
  },
  { onlyPublic: true }
)
